module.exports = __webpack_public_path__ + "static/media/pos-banner-top.935eea20.png";